module.exports = "/_next/static/resources/photo-3-1e2dacf36c0baa782f1fedf6415f50ae.jpg";